export default __webpack_public_path__ + "static/media/polar_plains.19c6a1ed.svg";